import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Applogo } from "../../../Routes/ImagePath";
import { Api_Url } from "../../../config/config";
import axios from "axios";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { SuccessToast } from "../../ToastComponent";

// Define the validation schema using Yup
const validationSchema = Yup.object().shape({
  email: Yup.string().email("Invalid email format").required("Email is required"),
});

const ForgotPassword = () => {
  const navigate = useNavigate();

  // Initialize the useForm hook with the validation schema
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  // Handle form submission
  const handleForgetPass = async (data) => {
    try {
      const response = await axios.post(`${Api_Url}api/Account/forgot-password`, data);
      console.log("res", response);
      if (response?.data?.succeeded) {
        SuccessToast("Reset Password link send in your mail successfully.")
        navigate('/reset');
      } else {
        navigate('/forgot-password');
      }
    } catch (error) {
      console.error("Error", error);
    }
  };

  return (
    <div className="account-page">
      <div className="main-wrapper">
        <div className="account-content">
          <div className="container">
            <div className="account-logo">
              <Link to="/app/main/dashboard">
                <img src={Applogo} alt="Roha housing" />
              </Link>
            </div>
            <div className="account-box">
              <div className="account-wrapper">
                <h3 className="account-title">Forgot Password?</h3>
                <p className="account-subtitle">
                  Enter your email to get a password reset link
                </p>
                <form onSubmit={handleSubmit(handleForgetPass)}>
                  <div className="input-block">
                    <label>Email Address</label>
                    <input
                      className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                      type="text"
                      {...register("email")}
                    />
                    <span className="text-danger">
                      {errors.email?.message}
                    </span>
                  </div>
                  <div className="input-block text-center">
                    <button className="btn btn-primary account-btn" type="submit">
                      Enter
                    </button>
                  </div>
                  <div className="account-footer">
                    <p>
                      Remember your password? <Link to="/">Login</Link>
                    </p>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;







// import React, { useState } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { Applogo } from "../../../Routes/ImagePath";
// import { Api_Url } from "../../../config/config";
// import axios from "axios";

// const ForgotPassword = () => {

//   // const navigate = useNavigate()

// const [email,setEmail]  = useState('')

// const navigate = useNavigate()

// const handleForgetPass = async() =>{
//  try {
//   const data = {email}
//   const response = await axios.post(`${Api_Url}api/Account/forgot-password`,data)
//   console.log("res",response)
//   if (response.status === 200) {
//     navigate('/otp')
//   }else{
//     navigate('/forgot-password')
//   }
//  } catch (error) {
//   return error
//  }
// }



//   return (
//     <div className="account-page">
//       <div className="main-wrapper">
//         <div className="account-content">
//           <div className="container">
//             <div className="account-logo">
//               <Link to="/app/main/dashboard">
//                 <img src={Applogo} alt="Roha housing" />
//               </Link>
//             </div>
//             <div className="account-box">
//               <div className="account-wrapper">
//                 <h3 className="account-title">Forgot Password?</h3>
//                 <p className="account-subtitle">
//                   Enter your email to get a password reset link
//                 </p>
//                 <form>
//                   <div className="input-block">
//                     <label>Email Address</label>
//                     <input className="form-control" 
//                     type="text"
//                     value={email}
//                     onChange={(e)=>setEmail(e.target.value)} />
//                   </div>
//                   <div className="input-block text-center">
//                     <button
//                       className="btn btn-primary account-btn"
//                       type="button" onClick={handleForgetPass}>
//                       Get OTP
//                     </button>
//                   </div>
//                   <div className="account-footer">
//                     <p>
//                       Remember your password? <Link to="/" >Login</Link>
//                     </p>
//                   </div>
//                 </form>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };
// export default ForgotPassword;
